var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.35 18H4.65C3.74 18 3 17.26 3 16.35V8.65C3 7.74 3.74 7 4.65 7H15.35C16.26 7 17 7.74 17 8.65V16.34C17 17.25 16.26 17.99 15.35 17.99V18ZM4.65 8C4.29 8 4 8.29 4 8.65V16.34C4 16.7 4.29 16.99 4.65 16.99H15.35C15.71 16.99 16 16.7 16 16.34V8.65C16 8.29 15.71 8 15.35 8H4.65Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.54 8H5.45996V6.54C5.45996 4.04 7.49996 2 9.99996 2C12.5 2 14.54 4.04 14.54 6.54V8ZM6.45996 7H13.54V6.54C13.54 4.59 11.95 3 9.99996 3C8.04996 3 6.45996 4.59 6.45996 6.54V7Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 13.5C14.5523 13.5 15 13.0523 15 12.5C15 11.9477 14.5523 11.5 14 11.5C13.4477 11.5 13 11.9477 13 12.5C13 13.0523 13.4477 13.5 14 13.5Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.5C10.5523 13.5 11 13.0523 11 12.5C11 11.9477 10.5523 11.5 10 11.5C9.44772 11.5 9 11.9477 9 12.5C9 13.0523 9.44772 13.5 10 13.5Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 13.5C6.55228 13.5 7 13.0523 7 12.5C7 11.9477 6.55228 11.5 6 11.5C5.44772 11.5 5 11.9477 5 12.5C5 13.0523 5.44772 13.5 6 13.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLock);
export default __webpack_public_path__ + "static/media/icon-lock.d6de0c11494f8b21220bbcec520207d6.svg";
export { ForwardRef as ReactComponent };